const Backbone = require('backbone')

module.exports = Backbone.Model.extend({
  defaults: {
    category: ['all'],
    defaultFormat: 'flash',
    description: '',
    forFunPlayUrl: '',
    flashPlayerNeeded: false,
    html5Dir: '',
    html5Path: '',
    html5ReleasePath: '',
    htmlType: 'js',
    image: '',
    imagePath: 'http://casino-client/uploads/media/game/0001/01/thumb_69_game_small.jpg',
    isHtml5Enabled: false,
    isPlayForFunPermitted: false,
    isPlayPermitted: false,
    isRealPlayPermitted: false,
    languages: ['en'],
    name: '',
    number: 0,
    provider: 'egaming.internal',
    realPlayUrl: '',
    searchIndex: 'game',
    slug: '',
    unfinished: false,
  },

  PROVIDER_INTERNAL: 'egaming.internal',

  constructor: function constructor(data, params) {
    // eslint-disable-next-line prefer-rest-params
    Backbone.Model.apply(this, arguments)

    const format = 'html'

    this.collection = params && params.collection
    this.set('format', format)
    this.set('isExternal', this.get('provider').indexOf('egaming.internal') === -1)
    this.set('isPlayPermitted', this.get('isRealPlayPermitted') || this.get('isPlayForFunPermitted'))

    if (this.isInFungamesCategory()) {
      this.set('isRealPlayPermitted', false)
      this.set('fungameOnly', true)
    }

    // if (DEBUG && this.get('slug') === 'blackjack') {
    //     this.set('unfinished', true);
    // }
  },

  isInFungamesCategory() {
    if (!this.collection) {
      return false
    }
    return this.get('category').indexOf(this.collection.fungamesCategory) > -1
  },
})
